// extracted by mini-css-extract-plugin
module.exports = {"container":"Workbooks_container__1noYh","workbooks":"Workbooks_workbooks__-mt9-","buttonCreateWorkbook":"Workbooks_buttonCreateWorkbook__379lY"};